// @flow

// Libs
import { createSelector } from 'reselect'

// Selectors
import { userId$ } from 'fc-authenticated-user'

// DataTable Composer
import composeDataTable from 'fc-component-datatable'

// Hocs
import usersDataTableHoc from './hocs/UsersDataTable'

// Constants
import {
  PROP_ID,
  PROP_FIRST,
  PROP_LAST,
  PROP_USERNAME,
  PROP_PARENT,
  PROP_PHONE,
  PROP_USER_EMAIL,
} from 'fc-model-users'
import {
  DATATABLE_NAME,
  ATTR_LAST,
  ATTR_FIRST,
  ATTR_USERNAME,
  ATTR_PHONE,
  ATTR_EMAIL,
  ATTR_ID,
  ATTR_PROP_HIDE_CHECKBOX,
} from './constants'


// Types
import type { User } from 'fc-model-users/types'
import type { UserRecord } from '../types'
import type {
  DataTableState,
  DataTableModule,
} from 'fc-component-datatable/types'
type ComposeUsersDataTableArgs = {
  users$: (state: Object) => Array<User>,
  tableState$: (state: Object) => DataTableState,
}

// Exports
export default function composeUsersDataTable ({
  users$,
  tableState$,
  }: ComposeUsersDataTableArgs): DataTableModule<User, UserRecord> {
  //
  function makeRecords (records$: (state: Object) => Array<User>): (state: Object) => Array<UserRecord> {
    return createSelector(
      [records$, userId$],
      function (users: Array<User>, userId: number): Array<UserRecord> {
        console.warn('Recompute Records')
        return users.map((user: User): UserRecord => {
          return {
            [ATTR_LAST]: user[PROP_LAST],
            [ATTR_FIRST]: user[PROP_FIRST],
            [ATTR_USERNAME]: user[PROP_USERNAME],
            [ATTR_PHONE]: user[PROP_PHONE],
            [ATTR_EMAIL]: user[PROP_USER_EMAIL],
            [ATTR_ID]: user[PROP_ID],
            [ATTR_PROP_HIDE_CHECKBOX]: !(userId === user[PROP_PARENT] || userId === user[PROP_ID]),
          }
        })
      }
    )
  }

  const datatable: DataTableModule<User, UserRecord> = composeDataTable({name: DATATABLE_NAME})({
    data$: users$,
    tableState$,
    makeRecords,
  })

  return {
    ...datatable,
    DataTable: usersDataTableHoc(datatable.DataTable),
  }
}
